import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=ce97e6b6&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "./orderList.vue?vue&type=style&index=0&id=ce97e6b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce97e6b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce97e6b6')) {
      api.createRecord('ce97e6b6', component.options)
    } else {
      api.reload('ce97e6b6', component.options)
    }
    module.hot.accept("./orderList.vue?vue&type=template&id=ce97e6b6&scoped=true", function () {
      api.rerender('ce97e6b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderManage/orderList.vue"
export default component.exports